import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonService } from '@services/app.common.service';


@Injectable()
export class CustomTranslateLoader implements TranslateLoader {
  contentHeader = new HttpHeaders({ "Content-Type": "application/json", responseType: 'text', "Access-Control-Allow-Origin": "*" });
  public _baseUrl: string;
  public storageKey: string='';
  public gateWayUrl: string=''
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, public common: CommonService) {
    this._baseUrl = baseUrl;
  }
  getTranslation(lang: string): Observable<any> {
    if (lang == null || lang == "")
      lang = "en";

    lang = this.storageKey + lang;


    let apiAddress = this.gateWayUrl + "Translation/GetTranslationFile" + "?language=" + lang;
    let translation:any = null
    if (environment.production)
      translation = null;

    translation = null;

    if (translation == null) {
      return new Observable(observer =>  {
        this.http.get("assets/i18n/en.json", { headers: this.contentHeader }).subscribe((res: any) => {
          localStorage.removeItem(lang);
          localStorage.setItem(lang, JSON.stringify(res));
          observer.next(res);
          observer.complete();
        },
          error => {
            console.log(error)
          }
        );
      });
    }
    else {
      return new Observable(observer => {
        observer.next(translation);
        observer.complete();
      },
      );
    }
  }
  public deepMerge(target: any, source: any) {
    if (typeof target !== 'object' || typeof source !== 'object') return false; // target or source or both ain't objects, merging doesn't make sense
    for (var prop in source) {
      if (!source.hasOwnProperty(prop)) continue; // take into consideration only object's own properties.
      if (prop in target) { // handling merging of two properties with equal names
        if (typeof target[prop] !== 'object') {
          target[prop] = source[prop];
        } else {
          if (typeof source[prop] !== 'object') {
            target[prop] = source[prop];
          } else {
            if (target[prop].concat && source[prop].concat) { // two arrays get concatenated
              target[prop] = target[prop].concat(source[prop]);
            } else { // two objects get merged recursively
              target[prop] = this.deepMerge(target[prop], source[prop]);
            }
          }
        }
      } else { // new properties get added to target
        target[prop] = source[prop];
      }
    }
    return target;
  }
}
